/**
 * Product Group Label Formatter
 * Splits the label text (e.g., "Size: 4ft XL 80lb" or "Color: Red") and wraps the value in a bold span
 */
(() => {
  const formatProductGroupLabels = () => {
    const labels = document.querySelectorAll(
      '.fd-options-button > label > div, ' +
      '.fd-options-button .fd-flex:first-child > div, ' +
      '.fd-options-swatch > label > div, ' +
      '.fd-options-swatch > label[data-groups-swatch-editor-id="label"] > div'
    );
    
    for (const label of labels) {
      // Skip if already formatted
      if (label.querySelector('.fd-label-value')) continue;
      
      const text = label.textContent;
      const colonIndex = text.indexOf(':');
      
      if (colonIndex !== -1) {
        const labelName = text.substring(0, colonIndex + 1);
        const labelValue = text.substring(colonIndex + 1).trim();
        
        label.innerHTML = `${labelName} <span class="fd-label-value">${labelValue}</span>`;
      }
    }
  };

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', formatProductGroupLabels);
  } else {
    formatProductGroupLabels();
  }

  // Also observe for dynamically added content (app may load async)
  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.addedNodes.length) {
        formatProductGroupLabels();
      }
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();

